<template>
    <svg
        width="22"
        height="20"
        viewBox="0 0 22 20"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M16.0396 0C15.0078 0.0156446 13.9985 0.296417 13.1137 0.813962C12.2288 1.33151 11.4997 2.0675 11 2.94761C10.5003 2.0675 9.77118 1.33151 8.88632 0.813962C8.00146 0.296417 6.99216 0.0156446 5.96037 0C4.31556 0.0696625 2.76589 0.771072 1.64991 1.95099C0.533927 3.13091 -0.0576437 4.69343 0.00443589 6.29717C0.00443589 12.3487 10.0434 19.3381 10.4704 19.6347L11 20L11.5296 19.6347C11.9566 19.3399 21.9956 12.3487 21.9956 6.29717C22.0576 4.69343 21.4661 3.13091 20.3501 1.95099C19.2341 0.771072 17.6844 0.0696625 16.0396 0Z"
        />
    </svg>
</template>

<script>
export default {
    setup() {
        return {};
    }
};
</script>

<style lang="scss" scoped></style>
